<template>
  <div>
    <barcode-scanner @scan-init="scanBarcode($event)" />
    <v-dialog
      v-model="showDetailsDialog"
      width="1600"
      eager
    >
      <v-card
        v-if="selectedProduct && showDetailsDialog"
        tile
      >
        <v-app-bar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>{{ selectedProduct.name }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              v-show="cashRegister.openedReport"
              :loading="$wait.is(`${selectedProduct.id} adding to cart`)"
              class="ml-0 block"
              color="white"
              text
              depressed
              @click="addToCart(selectedProduct)"
            >
              <v-icon
                left
                small
              >far fa-shopping-basket</v-icon>
              {{ $t('Add to {0}', [$t('Cart').toLowerCase()]) }}
            </v-btn>
            <v-divider vertical/>
            <v-btn
              dark
              icon
              @click.native="showDetailsDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-app-bar>
        <v-container
          fluid
          grid-list-md
        >
          <liquid-details
            v-if="selectedProduct && showDetailsDialog"
            :product-object="selectedProduct"
            @added-to-cart="addToCart"
            @selected-alternative="showInfo($event)"
            @selected-flavor="$emit('selected-flavor', $event)"
            @next="selectNext"
            @previous="selectPrevious"
          />
        </v-container>
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="headers"
      :items="filteredProducts"
      :loading="$wait.is('fetching products')"
      v-bind="dataTableProps"
      :sort-by="['rating', 'superStar']"
      :sort-desc="[true, true]"
      @current-items="currentItems = $event"
    >
      <template v-slot:item="props">
        <tr
          style="cursor: pointer"
          @click="showInfo(props.item)"
        >
          <td>
            <template v-if="$store.getters.locale === $store.state.secondaryLocale">{{ props.item.nameTranslated }}</template>
            <template v-else>{{ props.item.name }}</template>
          </td>
          <td>
            <stock-chip
              :value="_.get(props, 'item.storeStock.stock', 0)"
              :loading="$wait.is('fetching product stocks')"
            />
          </td>
          <td>{{ _.get(props, 'item.brand.name', '-') }}</td>
          <td>{{ _.get(props, 'item.pgVgRatio', '-') }}</td>
          <td>
            <template >{{ props.item.retailPromo ? props.item.retailPromo : props.item.retailPrice | money }}</template>
          </td>
          <td>
            <div class="d-flex align-center">
              <v-rating
                :value="props.item.rating/2"
                background-color="orange lighten-3"
                half-increments
                half-icon="far fa-star-half-stroke"
                readonly
                color="orange"
                length="5"
                size="12"
              />
              <v-icon
                v-if="props.item.superStar"
                :color="props.item.rating > 8 ? '#FFD700' : '#c0c0c0'"
                size="18px"
                class="ml-2"
              >fas fa-medal</v-icon>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <select-tax-stamp-dialog
      :show-dialog="showTaxStampDialog"
      :item="selectedProduct"
      @item-selected="selectTaxStamp($event)"
      @closed="showTaxStampDialog = false" />
  </div>
</template>

<script>
import StockChip from '@/components/chips/StockChip'
import { VDataTableDefaultProps as dataTableProps } from '@/utils/default-props/v-data-table'
import { fuzzyfilterProducts } from '@/utils/functions'
import LiquidDetails from './LiquidDetails'
import BarcodeScanner from '../BarcodeScanner'
import SelectTaxStampDialog from '@/components/dialogs/SelectTaxStampDialog'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Results',

  components: {
    BarcodeScanner,
    LiquidDetails,
    StockChip,
    SelectTaxStampDialog
  },

  props: {
    searchParams: {
      default: null,
      required: true,
      type: Object
    }
  },

  data () {
    return {
      headers: [
        {
          text: this.$t('Name'),
          value: 'name',
          width: '30%',
          sortable: false,
          class: 'grey lighten-3'
        },
        {
          text: this.$t('Stock'),
          value: 'storeStock.stock',
          sortable: false,
          class: 'grey lighten-3'
        },
        {
          text: this.$t('Brand'),
          value: 'brand.name',
          sortable: false,
          class: 'grey lighten-3'
        },
        {
          text: this.$t('VG/PG Ratio'),
          value: 'pgVgRatio',
          sortable: false,
          class: 'grey lighten-3'
        },
        {
          text: this.$t('Price'),
          value: 'retailPrice',
          sortable: false,
          class: 'grey lighten-3'
        },
        {
          text: this.$t('Score'),
          value: 'rating',
          sortable: false,
          width: '120px',
          class: 'grey lighten-3'
        }
      ],
      currentItems: [],
      products: [],
      filteredProducts: [],
      showDetailsDialog: false,
      selectedProduct: null,
      dataTableProps,
      scannedBarcode: null,
      showTaxStampDialog: false,
      test: null
    }
  },

  computed: {
    ...mapState(['cashRegister']),
    ...mapGetters('RECEIPT', { receiptProducts: 'products' })
  },

  watch: {
    searchParams: {
      immediate: true,
      deep: true,
      handler () {
        this.fuzzy()
      }
    }
  },

  created () {
    this.updateResults()
  },

  methods: {
    addToCart (item) {
      this.selectedProduct = item
      if (item.retailPriceTax > 0) {
        this.showTaxStampDialog = true
      } else {
        this.$wait.start(`${item.id} adding to cart`)
        return this.$store.dispatch('RECEIPT/ADD_PRODUCT', { id: item.id, qty: 1, returnType: this.returnType })
          .then(data => {
            item.receiptProduct = data.receiptProduct
            this.$emit('added-to-cart', item)
            // this.showDetailsDialog = false
            this.helpers.toastSuccess(data.message)
          })
          .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
          .finally(() => this.$wait.end(`${item.id} adding to cart`))
      }
    },
    selectTaxStamp (value) {
      this.$wait.start(`${this.selectedProduct.id} adding to cart`)
      return this.$store.dispatch('RECEIPT/ADD_PRODUCT', { id: this.selectedProduct.id, qty: 1, has_tax_stamp: value })
        .then(data => {
          this.selectedProduct.receiptProduct = data.receiptProduct
          this.helpers.toastSuccess(data.message)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => {
          this.$wait.end(`${this.selectedProduct.id} adding to cart`)
          this.showTaxStampDialog = false
          this.$emit('added-to-cart', this.selectedProduct)
        })
    },
    fuzzy () {
      if (!this.searchParams.searchQuery) {
        this.filteredProducts = this.products
      } else {
        this.filteredProducts = fuzzyfilterProducts(this.searchParams.searchQuery, this.products)
      }

      this.filteredProducts = this.filteredProducts.filter(item => {
        const tags = item.tags.map(tag => tag.filterName)
        const volumes = item.attributeOptions.map(attr => attr.name)

        let hasFlavorProfile = true
        let hasFlavor = true
        let hasVolume = true
        let hasPgVgRatio = true
        let hasFamily = true

        // filter op tags
        if (_.get(this.searchParams.flavorProfile, 'length', 0) > 0) {
          hasFlavorProfile = this.searchParams.flavorProfile.every(tag => tags.includes(tag))
        }

        if (_.get(this.searchParams.flavor, 'length', 0) > 0) {
          hasFlavor = this.searchParams.flavorCondition === 'AND'
            ? this.searchParams.flavor.every(tag => tags.includes(tag))
            : this.searchParams.flavor.some(tag => tags.includes(tag))
        }

        // filter op families
        if (_.get(this.searchParams.family, 'length', 0) > 0) {
          hasFamily = this.searchParams.family.some(tag => tags.includes(tag))
        }

        if (_.get(this.searchParams.pgVgRatio, 'length', 0) > 0) {
          hasPgVgRatio = item.pgVgRatio && this.searchParams.pgVgRatio.some(pgVgRatio => pgVgRatio === item.pgVgRatioCode)
        }

        if (_.get(this.searchParams.volume, 'length', 0) > 0) {
          hasVolume = this.searchParams.volume.some(volume => volumes.includes(volume))
        }

        // alle filters moeten overeenkomen
        return hasFlavorProfile && hasFlavor && hasFamily && hasVolume && hasPgVgRatio
      })
    },

    fuzzyDebounced: _.debounce(function () {
      this.fuzzy()
    }, 300),

    hideInfo () {
      this.selectedProduct = null
      this.showDetailsDialog = false
    },

    scanBarcode (barcode) {
      this.scannedBarcode = barcode
      const items = this.products.filter((item) => {
        // find each product where the property "barcodes" contains the scanned barcode
        return item.barcodes.includes(barcode)
      })

      // Show the product in dialog if one producted matched
      // Else filter the datatable
      if (!items.length) {
        this.helpers.toastError(this.$t('No results found.'))
      } else if (items.length === 1) {
        this.selectedProduct = items[0]
        this.showDetailsDialog = true
      } else {
        this.filteredProducts = items
      }
    },

    selectNext () {
      const currentIndex = this.currentItems.indexOf(this.selectedProduct)
      const nextIndex = (currentIndex + 1) % this.currentItems.length
      this.showInfo(this.currentItems[nextIndex])
    },

    selectPrevious () {
      const currentIndex = this.currentItems.indexOf(this.selectedProduct)
      const previousIndex = (currentIndex - 1 + this.currentItems.length) % this.currentItems.length
      this.showInfo(this.currentItems[previousIndex])
    },

    showInfo (item) {
      this.selectedProduct = item
      this.showDetailsDialog = true
    },

    updateResults () {
      this.showDetailsDialog = false
      this.$wait.start('fetching products')

      // ELSE
      // update the datatable items when store state has changed (async call in App.vue created)
      this.$store.watch(
        (state) => state.products,
        (products) => {
          this.products = products.filter(product => {
            // At least one family tag should match the given tag slugs
            // Calling .every instead of .some also return products that have no tags
            return product.tags.filter(tag => tag.type === 'family').some(tag => ['aroma', 'e-liquid-nicsalt', 'e-liquid-shake-vape', 'e-liquid-nicotine'].includes(tag.slug))
          })

          if (products.length) {
            this.$wait.end('fetching products')
          }
          this.fuzzy()
        },
        { immediate: true }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-rating /deep/ .v-icon {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/vapevault/Results.vue